var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.251 5.16675C10.251 4.8906 10.0111 4.66675 9.71525 4.66675C9.41936 4.66675 9.17953 4.8906 9.17953 5.16675C9.17953 6.78395 8.79673 7.83425 8.09575 8.48851C7.39474 9.14283 6.26941 9.50011 4.53669 9.50011C4.24082 9.50011 4.00098 9.72395 4.00098 10.0001C4.00098 10.2762 4.24082 10.5001 4.53669 10.5001C6.26941 10.5001 7.39474 10.8573 8.09575 11.5116C8.79673 12.1659 9.17953 13.2162 9.17953 14.8334C9.17953 15.1095 9.41936 15.3334 9.71525 15.3334C10.0111 15.3334 10.251 15.1095 10.251 14.8334C10.251 13.2162 10.6338 12.1659 11.3347 11.5116C12.0358 10.8573 13.1611 10.5001 14.8938 10.5001C15.1897 10.5001 15.4296 10.2762 15.4296 10.0001C15.4296 9.72395 15.1897 9.50011 14.8938 9.50011C13.1611 9.50011 12.0358 9.14283 11.3347 8.48851C10.6338 7.83425 10.251 6.78395 10.251 5.16675Z",
    fill: "url(#paint0_linear_1612_301)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71456 3.66683C4.71456 3.48274 4.55466 3.3335 4.35742 3.3335C4.16018 3.3335 4.00028 3.48274 4.00028 3.66683C4.00028 4.32058 3.84513 4.71523 3.59149 4.95196C3.33785 5.18869 2.91502 5.3335 2.21456 5.3335C2.01732 5.3335 1.85742 5.48274 1.85742 5.66683C1.85742 5.85092 2.01732 6.00016 2.21456 6.00016C2.91502 6.00016 3.33785 6.14497 3.59149 6.3817C3.84513 6.61842 4.00028 7.01307 4.00028 7.66683C4.00028 7.85092 4.16018 8.00019 4.35742 8.00019C4.55466 8.00019 4.71456 7.85092 4.71456 7.66683C4.71456 7.01307 4.86971 6.61842 5.12335 6.3817C5.37699 6.14497 5.79982 6.00016 6.50027 6.00016C6.69752 6.00016 6.85742 5.85092 6.85742 5.66683C6.85742 5.48274 6.69752 5.3335 6.50027 5.3335C5.79982 5.3335 5.37699 5.18869 5.12335 4.95196C4.86971 4.71523 4.71456 4.32058 4.71456 3.66683Z",
    fill: "url(#paint1_linear_1612_301)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28544 1.00008C8.28544 0.815983 8.12554 0.666748 7.92829 0.666748C7.73104 0.666748 7.57114 0.815983 7.57114 1.00008C7.57114 1.42235 7.47056 1.65034 7.33349 1.77827C7.19642 1.9062 6.95216 2.00008 6.49972 2.00008C6.30248 2.00008 6.14258 2.14932 6.14258 2.33342C6.14258 2.51751 6.30248 2.66675 6.49972 2.66675C6.95216 2.66675 7.19642 2.76063 7.33349 2.88856C7.47056 3.0165 7.57114 3.24448 7.57114 3.66675C7.57114 3.85084 7.73104 4.00008 7.92829 4.00008C8.12554 4.00008 8.28544 3.85084 8.28544 3.66675C8.28544 3.24448 8.38602 3.0165 8.52309 2.88856C8.66014 2.76063 8.90442 2.66675 9.35682 2.66675C9.55414 2.66675 9.71399 2.51751 9.71399 2.33342C9.71399 2.14932 9.55414 2.00008 9.35682 2.00008C8.90442 2.00008 8.66014 1.9062 8.52309 1.77827C8.38602 1.65034 8.28544 1.42235 8.28544 1.00008Z",
    fill: "url(#paint2_linear_1612_301)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1612_301",
    x1: 4.04179,
    y1: 9.99972,
    x2: 15.4316,
    y2: 9.96411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1612_301",
    x1: 1.87528,
    y1: 5.66669,
    x2: 6.85833,
    y2: 5.65111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1612_301",
    x1: 6.15533,
    y1: 2.3333,
    x2: 9.71464,
    y2: 2.32218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar02);
export default __webpack_public_path__ + "static/media/star02.49ac09e067ba8f40aeb0078c241c8cb7.svg";
export { ForwardRef as ReactComponent };